import appStore from 'redux/stores/app.store';
import { useOrderDetailDialogProductsSectionLang } from './useOrderDetailDialogProductsSectionLang';

import type { OrderId } from 'shared/domain';

export function useOrderDetailDialogProductsSection() {
  const { whims = [], productsByCorridor = {} } =
    appStore.getOrderDetailInOrderDetailDialog() ?? {};
  const order = appStore.getOrderDetailInOrderDetailDialog();
  const orderId: OrderId = order?.id ?? NaN;
  const isBeingManaged = appStore.isOrderBeingManaged(orderId) ?? false;

  const lang = useOrderDetailDialogProductsSectionLang();

  return {
    lang,
    orderId,
    productsByCorridor,
    whims,
    isBeingManaged,
    isAuditable: order?.is_auditable ?? false,
  };
}
